import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscriber } from 'rxjs';
import { AuthService } from '@schoolbelle/api/auth';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent implements OnInit {
  subscriptions = new Subscriber();
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.auth.user.subscribe((user) => {
        if (!user) {
          this.router.navigate(['/login'], {
            queryParams: {
              redirect_uri: this.router.routerState.snapshot.url,
            },
          });
        }
      }),
    );
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
